import React from "react"
import * as Yup from 'yup'
import { useFormik } from "formik"
import Field from "../../fields/Field"
import { Button } from "@mui/material"
import { store } from "../../../../stores/Store"
import Ajax from "../../../../Ajax"
import { Alert } from "../../../.."
import { format } from "date-fns"
import JobSelectField from "../../JobSelectField"


const Wrapper = ({children}) => {
    return (
        <div className="form">
            <h2>Create Assessment<span style={{color: "grey", fontWeight: 400}}> - Job Details</span></h2>
            {children}
        </div>
    )
}


export default function EnquiryJobFormSection ({
    hidden,
    caseUid,
    subjectData,
    onCancel = () => {},
    onSubmit = async (data) => {},
}) {

    const [jobOptions, setjobOptions] = React.useState([])
    const [jobAction, setJobAction] = React.useState("new")
    const [accountUid, setAccountUid] = React.useState(null)

    React.useEffect(() => {
        
        store.NodeStore.getAccountByCaseUid(caseUid).then(account => {
            
            var jobNodes = account.childrenObjects.filter(co => co.uid.includes("JOB"))
            var jOptions = jobNodes.map(jobNode => {
                var jobStartDate = format(new Date(jobNode.fromDate), "yyyy-MM-dd")
                return {value: jobNode.uid, label: `${jobNode.label}`, help: jobStartDate}
            })
            jOptions = jOptions.sort((a, b) => a.help?.localeCompare(b.help))
            setjobOptions(jOptions)
            setAccountUid(account.uid)
        
        }).catch(response => {
            Alert({message: response.data?.detail ? response.data?.detail : "Failed to get Job options"})
        })
    }, [])

    const handleCancel = () => {
        onCancel()
    }

    if (hidden) return <></>

    if (jobOptions == null) return <p>Loading job options</p>
    
    return (
        <Wrapper>
            {jobOptions?.length && jobAction === "new" ? (
                <p>Enter the basic details of the Job <span className="link" onClick={() => setJobAction("existing")}>or select an existing job</span>.</p>
            ) : null}

            {jobOptions?.length && jobAction === "existing" ? (
                <p>Select an existing Job <span className="link" onClick={() => setJobAction("new")}>or create new job</span>.</p>
            ) : null}

            {jobAction === "existing" ? (
                <JobSelectForm 
                    accountUid={accountUid}
                    onSubmit={async (jobUid) => await onSubmit({jobUid: jobUid})} 
                    onCancel={() => handleCancel()} />
            ) : null}

            {jobAction === "new" ? (
                <NewJobForm 
                    subjectData={subjectData}
                    onSubmit={async (jobInfo) => await onSubmit({jobInfo: jobInfo})} 
                    onCancel={() => handleCancel()} />
            ) : null}

            {!jobAction ? (
                <div className="form-buttons">
                    <Button className="btn btn-sm" onClick={() => onCancel()}>
                        Back
                    </Button>
                </div>
            ) : null}
        </Wrapper>
    )
}

function JobSelectForm ({accountUid, onSubmit, onCancel}) {

    const [jobUid, setJobUid] = React.useState<string>(null)
    const [error, setError] = React.useState<string>(null)

    return (
        <div>
            <JobSelectField accountUid={accountUid} value={jobUid} onChange={(uid) => setJobUid(uid)} warning={error ? error : false} />

            <div className="form-buttons">
                <Button className="btn btn-sm" onClick={() => onCancel()}>
                    Back
                </Button>
                
                <Button 
                    disabled={!jobUid}
                    className="btn btn-sm" 
                    variant="contained" 
                    color="success"
                    onClick={() => {
                        if (!jobUid) {
                            setError("You must select a job")
                        } else {
                            onSubmit(jobUid)
                        }
                    }}>
                    {jobUid ? "Use this Job" : "Select a job"}
                </Button>
            </div>
        </div>
    )
}

function NewJobForm ({subjectData, onSubmit, onCancel}) {

    const formik = useFormik({

        initialValues: {
            job_title:          subjectData?.job_title ? subjectData.job_title : "",
            // job_from_date:     subjectData?.job_from_date ? subjectData.job_from_date : "",
            job_from_date:     format(new Date(), "yyyy-MM-dd")
        },

        validationSchema: Yup.object({
            job_title:          Yup.string().required("This field is required"),
            // job_from_date:     Yup.date().min(new Date(), "Start date must be in the future").required("This field is required")
        }),

        onSubmit: async (values, actions) => {
            await onSubmit({...values})
        }
    })

    return (
        <form onSubmit={formik.handleSubmit} style={{maxWidth: "100%", maxHeight: "60vh", overflow: "auto"}}>
            <div style={{maxWidth: "300px"}}>
                <Field.Text 
                    formik
                    name="job_title"
                    label="Job title"
                    value={formik.values.job_title}
                    warning={formik.submitCount && formik.errors.job_title ? formik.errors.job_title : ""}
                    onChange={formik.handleChange} />

                {/* <Field.Date 
                    formik
                    name="job_from_date"
                    label="When is this job available from?"
                    value={formik.values.job_from_date}
                    warning={formik.submitCount && formik.errors.job_from_date ? formik.errors.job_from_date : ""}
                    onChange={(e) => formik.setFieldValue("job_from_date", e.target.value)} /> */}
            </div>

            <div className="form-buttons">
                <Button className="btn btn-sm" onClick={() => onCancel()}>
                    Back
                </Button>
                
                <Button 
                    disabled={formik.isSubmitting}
                    className="btn btn-sm" 
                    variant="contained" 
                    color="success"
                    type="submit">
                    Submit
                </Button>
            </div>
        </form>
    )
}